import {DashboardModal} from "../DashboardModal"
import {closeHelpModal, selectHelpModal} from "../../../reducers/dashboardModalControlSlice"
import {useDispatch, useSelector} from "react-redux"
import {Box, Collapse, List, ListItem } from "@mui/material"
import {
	closeAllInstructions,
	selectAllInstructions
} from "../../../reducers/instructionVidsTreeSlice"
import InstructionsVidToggleIcon from "./InstructionsVidToggleIcon"
import {HelpNote, HelpVideo} from "./HelpNotes"


export function InstructionsHelp(){
	const dispatch = useDispatch()
	const openHelpModal = useSelector(selectHelpModal)
	const handleModalClose = () => {
		dispatch(closeAllInstructions())
		dispatch(closeHelpModal())
	}

	return (
		<DashboardModal
			open={openHelpModal}
			setClose={handleModalClose}
			title={"Help & Instructions"}
			stylePassThru={{
				"& .MuiDialog-paperWidthLg": {
					backgroundColor: "#e0e0e0",
				}
			}}
		>
			<HelpNotesTree />
		</DashboardModal>
	)
}

export function  HelpNotesTree() {
	const instructionsTree = useSelector(selectAllInstructions)
	return (
		<Box sx={{ minWidth: "600px", width: "60vw"}} >
			<List dense variant={"notetree"} toplevel={"true"}>
				{instructionsTree.map((instruction, index) => (
					<ListItem variant={"notetree"} toplevel={"true"} key={index}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								position: "relative",
								paddingRight: "15px",
								paddingY: "0.5px",
								alignItems: "center",
							}}
							className={"help-note-container"}
						>
							<InstructionsVidToggleIcon instruction={instruction} index={index} />
							<HelpNote instruction={instruction} index={index}/>
						</Box>
						<Collapse in={instruction.open}>
							<List dense variant={"notetree"} toplevel={"false"}>
								<ListItem variant={"notetree"} toplevel={"false"}>
									<Box
										sx={{
											display: "flex",
											flexDirection: "row",
											position: "relative",
											paddingRight: "15px",
											paddingY: "0.5px",
											alignItems: "center",
										}}
										className={"help-note-video-container"}
									>
										<span
											style={{
												maxWidth: "25px",
												minWidth: "25px",
												maxHeight: "30px",
											}}
										/>
										<HelpVideo
											instruction={instruction}
											setHeight={"560"}
											setWidth={"315"}
										/>
									</Box>
								</ListItem>
							</List>
						</Collapse>
					</ListItem>
				))}
			</List>
		</Box>
	)
}